import React, { useState, useEffect, useContext } from "react";
import "./Profile_Vendor.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import Account_Created_Modal from "../login/account-created-modal/Account_Created_Modal";
import {
  GETVendor,
  Update_Vendor,
  Update_Vendor_Shop,
} from "../../../features/admin/auth/Slice";
import { Context } from "../../../utils/context";
import { useDispatch, useSelector } from "react-redux";
import {
  AllState,
  AllDistrict,
  AllCartegory,
  AllSubServiceCategories,
} from "../../../features/admin/common/Slice";
import Select from "react-select";
import { IDS } from "../../../utils/IDS";

const Profile_Vendor = () => {
  const dispatch = useDispatch();
  const { userdata } = useContext(Context);

  const states = useSelector((state) => state?.common?.all_state);
  const districts = useSelector((state) => state?.common?.all_district);
  const all_category = useSelector((state) => state?.common?.all_category);
  const subServiceCategories = useSelector(
    (state) => state?.common?.all_sub_service_categories,
  );

  const vendorGet = useSelector((state) => state?.auth?.login?.getVendorData);
  console.log(vendorGet, "vendorGetvendorGet");

  const [isEditing, setIsEditing] = useState(false);
  const [activeTab, setActiveTab] = useState("personal");
  const [showSuccess, setShowSuccess] = useState(false);

  const [profileImage, setProfileImage] = useState(
    "/assets/images/profile-icon.png",
  );
  const [profileFile, setProfileFile] = useState(null);
  const [licenseFile, setLicenseFile] = useState(null);
  const [shopImage1, setShopImage1] = useState(null);
  const [shopImage2, setShopImage2] = useState(null);

  const [licensePreview, setLicensePreview] = useState(null);
  const [shopPreview1, setShopPreview1] = useState(null);
  const [shopPreview2, setShopPreview2] = useState(null);

  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    mobile_number: "",
    whatsapp_no: "",
    state: null,
    state_id: null,
    district: null,
    district_id: null,
    shop_name: "",
    category: [],
    sub_category: [],
    credit_udhar: 1,
  });

  // ====================== Select Styles ======================
  const selectStyles = {
    control: (base) => ({
      ...base,
      height: "45px",
      borderRadius: "30px",
      border: "1px solid #ddd",
      boxShadow: "none",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({ ...base, padding: "0 20px" }),
  };

  const catSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "45px",
      borderRadius: "30px",
      paddingTop: "15px",
      border: "1px solid #ddd",
      boxShadow: "none",
      "&:hover": { border: "1px solid #aaa" },
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({ ...base, padding: "0 20px" }),
  };

  // ====================== Fetch Initial Data ======================
  useEffect(() => {
    dispatch(GETVendor({ type: "profile" }));
    dispatch(AllState());
    dispatch(AllCartegory());
  }, [dispatch]);

  // ====================== Prefill Form ======================
  useEffect(() => {
    if (!vendorGet) return;

    setProfileImage(
      vendorGet.profile_pic
        ? `${IDS.IMG_URL}${vendorGet.profile_pic}`
        : "/assets/images/profile-icon.png",
    );

    const images = vendorGet?.vendor_shop_image || [];
    setShopPreview1(
      images[0]?.shop_image ? `${IDS.IMG_URL}${images[0].shop_image}` : null,
    );
    setShopPreview2(
      images[1]?.shop_image ? `${IDS.IMG_URL}${images[1].shop_image}` : null,
    );
    setLicensePreview(
      vendorGet?.vendor_shop_detail?.licen_image
        ? `${IDS.IMG_URL}${vendorGet.vendor_shop_detail.licen_image}`
        : null,
    );

    const categories =
      vendorGet.vendor_shop_detail?.service_category?.map((item) => ({
        label: item.material?.name,
        value: item.material_id,
      })) || [];

    const subCategories =
      vendorGet?.vendor_sub_material?.map((item) => ({
        label: item?.sab_category?.name,
        value: item?.sab_category?.id,
        service_category_id: item?.sab_category?.service_category_id,
      })) || [];

    setFormData({
      name: vendorGet.name || "",
      mobile_number: vendorGet.mobile_number || "",
      whatsapp_no: vendorGet.user_details?.whatsapp_no || "",
      state: vendorGet.user_details?.state
        ? {
            label: vendorGet.user_details.state.name,
            value: vendorGet.user_details.state.id,
          }
        : null,
      state_id: vendorGet.user_details?.state_id || null,
      district: vendorGet.user_details?.district
        ? {
            label: vendorGet.user_details.district.name,
            value: vendorGet.user_details.district.id,
          }
        : null,
      district_id: vendorGet.user_details?.district_id || null,
      shop_name: vendorGet.vendor_shop_detail?.shop_name || "",
      category: categories,
      sub_category: subCategories,
      credit_udhar: vendorGet.credit_udhar ?? 1,
    });

    if (categories.length > 0) {
      dispatch(
        AllSubServiceCategories({
          service_category_id: categories.map((c) => c.value),
        }),
      );
    }
  }, [vendorGet, dispatch]);

  // ====================== Fetch Sub Categories on Category Change ======================
  useEffect(() => {
    if (formData.category?.length > 0) {
      const categoryIds = formData.category.map((item) => item.value);
      dispatch(AllSubServiceCategories({ service_category_id: categoryIds }));
    } else {
      setFormData((prev) => ({ ...prev, sub_category: [] }));
    }
  }, [formData.category, dispatch]);

  // ====================== Handlers ======================
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "name" && !/^[a-zA-Z\s]*$/.test(value)) return;
    if (name === "mobile_number" && (!/^\d*$/.test(value) || value.length > 10))
      return;

    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleStateChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      state: selectedOption,
      state_id: selectedOption?.value || null,
      district: null,
      district_id: null,
    }));
    setErrors((prev) => ({ ...prev, state: "" }));

    if (selectedOption?.value) {
      dispatch(AllDistrict({ state_id: selectedOption.value }));
    }
  };

  const handleDistrictChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      district: selectedOption,
      district_id: selectedOption?.value || null,
    }));
    setErrors((prev) => ({ ...prev, district: "" }));
  };

  const handleCategoryChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      category: selectedOptions || [],
      sub_category: [], // reset when category changes
    }));
    setErrors((prev) => ({ ...prev, category: "" }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileFile(file);
      setProfileImage(URL.createObjectURL(file));
    }
  };

  const handleLicenseChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLicenseFile(file);
      setLicensePreview(URL.createObjectURL(file));
    }
  };

  const handleShopImage1Change = (e) => {
    const file = e.target.files[0];
    if (file) {
      setShopImage1(file);
      setShopPreview1(URL.createObjectURL(file));
    }
  };

  const handleShopImage2Change = (e) => {
    const file = e.target.files[0];
    if (file) {
      setShopImage2(file);
      setShopPreview2(URL.createObjectURL(file));
    }
  };

  // ====================== Submit ======================
  const handleButtonClick = async () => {
    if (!isEditing) {
      setIsEditing(true);
      return;
    }

    if (activeTab === "personal") {
      const newErrors = {};
      if (!formData.name.trim()) newErrors.name = "Name is required";
      if (!formData.mobile_number || formData.mobile_number.length !== 10)
        newErrors.mobile_number = "Valid 10 digit mobile is required";
      if (!formData.state_id) newErrors.state = "State is required";
      if (!formData.district_id) newErrors.district = "District is required";
      if (!formData.category.length)
        newErrors.category = "Category is required";

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      }

      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("mobile_number", formData.mobile_number);
      formDataToSend.append("whatsapp_no", formData.whatsapp_no);
      formDataToSend.append("state_id", formData.state_id);
      formDataToSend.append("district_id", formData.district_id);

      formData.category.forEach((c) =>
        formDataToSend.append("material_id[]", c.value),
      );
      formData.sub_category.forEach((sub) =>
        formDataToSend.append("sub_category_id[]", sub.value),
      );

      if (profileFile) formDataToSend.append("profile_pic", profileFile);

      const res = await dispatch(Update_Vendor(formDataToSend));
      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GETVendor({ type: "profile" }));
        setShowSuccess(true);
        setIsEditing(false);
      }
    }

    if (activeTab === "shop") {
      const shopFormData = new FormData();
      shopFormData.append("shop_name", formData.shop_name);

      if (shopImage1) shopFormData.append("shop_image[0]", shopImage1);
      if (shopImage2) shopFormData.append("shop_image[1]", shopImage2);
      if (licenseFile) shopFormData.append("shop_image[2]", licenseFile);

      const res = await dispatch(Update_Vendor_Shop(shopFormData));
      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GETVendor({ type: "profile" }));
        setShowSuccess(true);
        setIsEditing(false);
      }
    }
  };

  useEffect(() => {
    if (showSuccess) {
      const timer = setTimeout(() => {
        setShowSuccess(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showSuccess]);

  return (
    <div className="profile-wrapper">
      <div className="profile-container container">
        <div className="profile-card">
          <div className="profile-image-wrapper">
            <input
              type="file"
              id="profile-image-upload-vendor"
              hidden
              accept="image/*"
              onChange={handleFileChange}
            />
            <img src={profileImage} alt="profile" className="profile-image" />
            <label htmlFor="profile-image-upload-vendor" className="edit-icon">
              <FontAwesomeIcon icon={faPencilAlt} />
            </label>
          </div>

          <div className="profile-tabs">
            <button
              className={`tab-btn ${activeTab === "personal" ? "active" : ""}`}
              onClick={() => setActiveTab("personal")}
            >
              Personal
            </button>
            <button
              className={`tab-btn ${activeTab === "shop" ? "active" : ""}`}
              onClick={() => setActiveTab("shop")}
            >
              Shop
            </button>
          </div>

          <div className="profile-form">
            {activeTab === "personal" ? (
              <>
                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      disabled={!isEditing}
                    />
                    {errors.name && (
                      <span className="error-text">{errors.name}</span>
                    )}
                    <label>Full Name</label>
                  </div>

                  <div className="form-group">
                    <Select
                      value={formData.state}
                      options={states}
                      styles={selectStyles}
                      isDisabled={!isEditing}
                      onChange={handleStateChange}
                      placeholder=""
                    />
                    {errors.state && (
                      <span className="error-text">{errors.state}</span>
                    )}
                    <label className="floating-label">State</label>
                  </div>

                  <div className="form-group">
                    <Select
                      value={formData.district}
                      options={districts}
                      styles={selectStyles}
                      isDisabled={!isEditing || !formData.state}
                      onChange={handleDistrictChange}
                      placeholder=""
                    />
                    {errors.district && (
                      <span className="error-text">{errors.district}</span>
                    )}
                    <label className="floating-label">District</label>
                  </div>

                  <div className="form-group">
                    <Select
                      isMulti
                      value={formData.category}
                      options={all_category}
                      styles={catSelectStyles}
                      isDisabled={!isEditing}
                      onChange={handleCategoryChange}
                      placeholder=""
                    />
                    {errors.category && (
                      <span className="error-text">{errors.category}</span>
                    )}
                    <label className="floating-label">Category</label>
                  </div>

                  <div className="form-group">
                    <Select
                      isMulti
                      value={formData.sub_category}
                      options={subServiceCategories}
                      styles={catSelectStyles}
                      isDisabled={!isEditing || !formData.category.length}
                      onChange={(selected) =>
                        setFormData((prev) => ({
                          ...prev,
                          sub_category: selected || [],
                        }))
                      }
                      placeholder=""
                    />
                    <label className="floating-label">Sub Category</label>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="mobile_number"
                      value={formData.mobile_number}
                      onChange={handleChange}
                      disabled={!isEditing}
                    />
                    {errors.mobile_number && (
                      <span className="error-text">{errors.mobile_number}</span>
                    )}
                    <label>Mobile Number</label>
                  </div>
                </div>
              </>
            ) : (
              // <div className="form-row">
              //   <div className="form-group">
              //     <input
              //       type="text"
              //       name="shop_name"
              //       value={formData.shop_name}
              //       onChange={handleChange}
              //       disabled={!isEditing}
              //     />
              //     <label>Shop/Showroom Name</label>
              //   </div>

              //   <div className="row mt-3">
              //     <div className="col-lg-4">
              //       <input
              //         type="file"
              //         accept="image/*"
              //         disabled={!isEditing}
              //         onChange={handleLicenseChange}
              //       />
              //       <label>Shopact License</label>
              //       <div className="img_holder">
              //         {licensePreview && (
              //           <img
              //             src={licensePreview}
              //             className="preview-img"
              //             alt="license"
              //           />
              //         )}
              //       </div>
              //     </div>
              //     <div className="col-lg-4">
              //       <input
              //         type="file"
              //         accept="image/*"
              //         disabled={!isEditing}
              //         onChange={handleShopImage1Change}
              //       />
              //       <label>Shop Image 1</label>
              //       <div className="img_holder">
              //         {shopPreview1 && (
              //           <img
              //             src={shopPreview1}
              //             className="preview-img"
              //             alt="shop1"
              //           />
              //         )}
              //       </div>
              //     </div>
              //     <div className="col-lg-4">
              //       <input
              //         type="file"
              //         accept="image/*"
              //         disabled={!isEditing}
              //         onChange={handleShopImage2Change}
              //       />
              //       <label>Shop Image 2</label>
              //       <div className="img_holder">
              //         {shopPreview2 && (
              //           <img
              //             src={shopPreview2}
              //             className="preview-img"
              //             alt="shop2"
              //           />
              //         )}
              //       </div>
              //     </div>
              //   </div>
              // </div>
              <>
                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="shop_name"
                      value={formData.shop_name}
                      onChange={handleChange}
                      disabled={!isEditing}
                    />
                    <label>Shop/Showroom Name</label>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-4">
                    {/* License Image */}
                    <div className="form-group">
                      <input
                        type="file"
                        accept="image/*"
                        disabled={!isEditing}
                        onChange={handleLicenseChange}
                      />
                      <label>Shopact License</label>
                      {licensePreview && (
                        <div className="img_holder">
                          <img src={licensePreview} className="preview-img" />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    {/* Shop Image 1 */}
                    <div className="form-group">
                      <input
                        type="file"
                        accept="image/*"
                        disabled={!isEditing}
                        onChange={handleShopImage1Change}
                      />
                      <label>Shop Image</label>
                      {shopPreview1 && (
                        <div className="img_holder">
                          <img src={shopPreview1} className="preview-img" />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    {/* Shop Image 2 */}
                    <div className="form-group">
                      <input
                        type="file"
                        accept="image/*"
                        disabled={!isEditing}
                        onChange={handleShopImage2Change}
                      />
                      <label>Shop Image 2</label>
                      {shopPreview2 && (
                        <div className="img_holder">
                          <img src={shopPreview2} className="preview-img" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

            <button
              className={isEditing ? "save-profile-btn" : "edit-profile-btn"}
              onClick={handleButtonClick}
            >
              {isEditing ? "Save Profile" : "Edit Profile"}
            </button>
          </div>
        </div>
      </div>

      <Account_Created_Modal
        showAccountModal={showSuccess}
        handleAccountModalClose={() => setShowSuccess(false)}
        text="Profile Saved Successfully!"
      />
    </div>
  );
};

export default Profile_Vendor;
